import React from 'react';

import { HOME_PAGE_GAMES_AMOUNT } from '../constants';

const SkeletonItem = () => (
  <div className="game-item">
    <div>
      <div className="game-item-image skeleton" />
    </div>
    <div className="game-item-content">
      <div className="game-item-top skeleton" />
      <div className="game-item-bottom skeleton" />
    </div>
  </div>
);

const GameListSkeleton = () => (
  <div className="tile-games-container">
    {new Array(HOME_PAGE_GAMES_AMOUNT).map((v, i) => (
      <SkeletonItem key={i} />
    ))}
  </div>
);

export default GameListSkeleton;
